<template>
  <div>
    <div style="height: 100%; background-color: black">
      <div style="position: relative; z-index: 1">
        <v-toolbar dark color="black" classs="primary--text">
          <v-btn icon @click="goBack" classs="primary--text">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-toolbar-title>
            <strong>{{ title || "Scan QR code" }}</strong>
          </v-toolbar-title>
        </v-toolbar>
      </div>

      <div>
        <!-- <div
  id="loadingMessage"
  style="position: absolute"
  >Unable to access video stream (please make sure you have a webcam enabled)</div>-->
        <!--Added to ensure QR camera frame displays correctly across different browsers-->
        <video id="video-preview" class="fixed-center3"></video>
        <canvas id="qr-canvas" class="fixed-center" style="opacity: 0"></canvas>
      </div>

      <!-- Don't understand why -->
      <div class="fixed-center">
        <v-icon class="fixed-center" size="50vh" :color="videoLoaded ? '' : 'white'">mdi-crop-free</v-icon>
      </div>

      <!-- TODO: Remove these -->
      <!-- <div class="text-center" style="position: fixed; bottom: 8vh; width: 100vw">
    <v-btn @click="mockQr('invalid')" fab depressed class="bg-translucent ma-2">
      <v-icon color="white">mdi-alert-circle-outline</v-icon>
    </v-btn>

    <v-btn @click="mockQr('trl')" fab depressed class="bg-translucent ma-2">
      <v-icon color="white">mdi-checkbox-marked-circle-outline</v-icon>
    </v-btn>

    <v-btn @click="mockQr('jwpl')" fab depressed class="bg-translucent ma-2">
      <v-icon color="white">mdi-close-circle-outline</v-icon>
    </v-btn>
  </div> -->
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import qrScannerWeb from "@/helpers/qrScannerWeb";
import animator from "@/helpers/animator";

export default {
  name: "QRCodeScanner",
  props: {
    state: String,
    title: String
  },
  data() {
    return {
      audioBeep: null,
      videoLoaded: false,
      activated: false,
    };
  },
  methods: {
    ...mapMutations(["updateQRCode"]),
    mockQr(code) {
      const vm = this;

      let qrCode =
        "https://www.nlb.gov.sg/seatbooking/?xloc=NLB.JWPL.3.ExpressionCorner";

      if (code === "jwpl") {
        qrCode =
          "https://www.nlb.gov.sg/seatbooking/?loc=NLB.JWPL.3.ExpressionCorner";
      } else if (code === "trl") {
        qrCode =
          "https://www.nlb.gov.sg/seatbooking/?loc=NLB.TRL.5.StudyLounge";
      }

      vm.beep();

      setTimeout(() => {
        vm.updateQRCode({
          value: qrCode,
          state: this.state,
        });
      }, 10);

      vm.goBack();
    },
    startQRScanning() {
      //When this page is activated, QR scanner will start scanning,
      //the detected QR code (URL), will be stored in the store.QRCode in { value: text, state: this.state, } format
      //Next, the QRCode watcher of the component that initiated the QR scanning will handle it based on the state property in the result

      let vm = this;

      let successCallback = (text) => {
        vm.beep();

        setTimeout(() => {
          vm.updateQRCode({
            value: text,
            state: this.state,
          });
        }, 10);
      };

      let completeCallback = () => {
        vm.goBack();
      };

      qrScannerWeb.startQRScanning(
        successCallback,
        completeCallback,
        this.updateSystemDialog,
        () => {
          vm.videoLoaded = true;
        }
      );
    },
    stopQRScanning() {
      qrScannerWeb.stopQRScanning();
      this.videoLoaded = false;
    },
    beep(silentBeep) {
      let audioBeep = this.audioBeep;

      if (!audioBeep) {
        audioBeep = new Audio(`${this.audioPath}beep.mp3`)
        
        // audioBeep = new Audio(
        //   "data:audio/wav;base64,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"
        // );
      }

      if (silentBeep) {
        audioBeep.volume = 0;
      } else {
        audioBeep.volume = 1;
      }

      audioBeep.play();
    },
  },
  activated() {
    this.startQRScanning();
    // console.debug("state", this.state);
  },
  deactivated() {
    this.stopQRScanning();
  },
};
</script>

<style scoped>
.bg-translucent {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
